import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import PrePaidPlanForm from './PrePaidPlanForm'
import { withStyles, Paper } from '@material-ui/core';
import * as actions from '../../store/billingAccountActions';
import {BackButton, hasPermission, parseURL} from '../../../../sc-utilities';
import History from '../../../../../History';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        minHeight: '300px',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});

const PrePaidPlanCreate = props => {
    const { creating, classes, onPrepaidPlanCreate, activeCustomerID, translations, permissions } = props;
    const searchParams = parseURL(window.location.search)
    let AccountID = searchParams?.AccountID?? null

    const submitHandler = async data => {
        let formData = { ...data }
        formData['AccountID'] = AccountID
        await onPrepaidPlanCreate({ ...formData, ActiveCustomerID: activeCustomerID });
        History.goBack();
    };
    let initialValues = {
        Name: '',
        Credit: 0
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required('Required'),
            Credit: Yup.number().required('Required').min(1),
        },
        ButtonSubmit: hasPermission(permissions, 'prepaid_create') ? {
            Title: translations['save'] || 'SAVE',
            Color: 'primary'
        } : null,
        FormTitle: translations["create_prepaid_credit"] || "Create prepaid credit",
    };

    return <Paper className={classes.root}>
        {BackButton(translations, classes.customTooltip)}
        <PrePaidPlanForm loading={creating} handleSubmit={submitHandler} initialValues={initialValues} translations={translations} formSettings={formSettings} ></PrePaidPlanForm>
    </Paper>
};


const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        creating: state.billing.prepaids && state.billing.prepaids.creating ? state.billing.prepaids.creating : false,
        permissions: state?.core?.login?.permissions || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onPrepaidPlanCreate: params => dispatch(actions.onPrepaidPlanCreate(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PrePaidPlanCreate));